export const GOOGLE_PLAY_LINK =
  "https://play.google.com/store/apps/details?id=com.summithealth.mobile";
export const APPLE_STORE_LINK = "itms-apps://apps.apple.com/us/app/my-summit-health/id1565837885";
